import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import ApiService from '../services/ApiService';
import config from '../config';

const ChangeLog = () => {
  const [changeLog, setChangeLog] = useState('');
  const { version } = useSelector(state => state.app.config);

  useEffect(() => {
    ApiService.get('changelog').then(response => {
      setChangeLog(response.data.changeLog);
    });
  }, []);

  /* eslint-disable react/no-danger */
  return (
    <div className="about">
      <div className="title">
        <div className="logo">
          <img src={config.publicUrl('favicon.ico')} alt="Blaze" />
        </div>
        <div className="blaze">Blaze</div>
      </div>
      <h3>Version {version}</h3>
      <p>
        Copyright &copy; 2016 - {new Date().getFullYear()}{' '}
        <strong>
          <a href="https://dsisolutions.biz/">DSI Solutions</a>
        </strong>
        , All rights reserved.
      </p>
      <hr />
      <div className="changelog" dangerouslySetInnerHTML={{ __html: changeLog }} />
    </div>
  );
};

export default ChangeLog;
